var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bandeauComm"}},[_c('div',{attrs:{"id":"gaucheBandeauComm"}}),_c('div',{staticClass:"annonceBandeauComm"},[(!_vm.paramPRO)?_c('div',{attrs:{"id":"annonceBandeauComm"}}):_vm._e(),(_vm.paramPRO)?_c('div',{attrs:{"id":"annonceProBandeauComm"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }